import {
  IconAccessibility,
  IconChart,
  IconClock,
  IconCode,
  IconDashboard,
  IconDatabase,
  IconDownload,
  IconFileText,
  IconFlag,
  IconFolder,
  IconImage,
  IconGlobe,
  IconKey,
  IconPin,
  IconShield,
  IconSparkles,
  IconUtensils,
  IconUsers,
} from './icons';

export default function ModuleIcon({ moduleKey }) {
  if (moduleKey === 'dashboard') return <IconDashboard />;
  if (moduleKey === 'traffic') return <IconChart />;
  if (moduleKey === 'scripts') return <IconCode />;
  if (moduleKey === 'articles') return <IconFileText />;
  if (moduleKey === 'projects') return <IconFileText />;
  if (moduleKey === 'updates') return <IconSparkles />;
  if (moduleKey === 'settings') return <IconKey />;
  if (moduleKey === 'backups') return <IconDownload />;
  if (moduleKey === 'appointments') return <IconPin />;
  if (moduleKey === 'menus') return <IconUtensils />;
  if (moduleKey === 'team') return <IconUsers />;
  if (moduleKey === 'languages') return <IconFlag />;
  if (moduleKey === 'clients') return <IconUsers />;
  if (moduleKey === 'sites') return <IconGlobe />;
  if (moduleKey === 'accessibility') return <IconAccessibility />;
  if (moduleKey === 'resources') return <IconFolder />;
  if (moduleKey === 'gallery') return <IconImage />;
  if (moduleKey === 'databases') return <IconDatabase />;
  if (moduleKey === 'admin_settings') return <IconShield />;
  if (moduleKey === 'employees') return <IconUsers />;
  if (moduleKey === 'logs') return <IconClock />;
  return <IconFileText />;
}
